import type { CollectionState } from '@common/adapters/collections';
import type { SiteListEntity } from '@common/types/site.type';

import { createReducer, on } from '@ngrx/store';
import { createCollectionAdapter } from '@common/adapters/collections';

import SitesActions from './sites.actions';

export const SITES_COLLECTION_FEATURE_KEY = 'sites';

export type SitesCollectionState = CollectionState<SiteListEntity>;

export const sitesAdapter = createCollectionAdapter<SiteListEntity>();

export const sitesCollectionReducer = createReducer<SitesCollectionState>(
    sitesAdapter.getInitialState(),
    on(SitesActions.loadCollectionRequest, (state: SitesCollectionState) => sitesAdapter.loadCollectionRequest(state)),
    on(SitesActions.loadCollectionSuccess, (state: SitesCollectionState, { sites }) =>
        sitesAdapter.loadCollectionSuccess(sites, state)
    ),
    on(SitesActions.loadCollectionFailure, (state: SitesCollectionState, { error }) =>
        sitesAdapter.loadCollectionFailure(error, state)
    )
);
